import { render, staticRenderFns } from "./ReloadPrompt.vue?vue&type=template&id=5202b793&scoped=true"
import script from "./ReloadPrompt.vue?vue&type=script&lang=js"
export * from "./ReloadPrompt.vue?vue&type=script&lang=js"
import style0 from "./ReloadPrompt.vue?vue&type=style&index=0&id=5202b793&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5202b793",
  null
  
)

export default component.exports